import React from "react";
import CheckMark from "@tomocredit/common-fe/components/CheckMark";

const BoldText = ({ text }) => (
  <span className="font-bold">
    {text}
  </span>
);

const CheckMarkText = ({ children, className }) => (
  <CheckMark className={className} color="boost">
    <span className="ml-3 text-md">
      {children}
    </span>
  </CheckMark>
);

const TextCreditLine = () => <span>Up to <BoldText text='$30,000 credit line' /></span>;

const TextCreditBoost = () => <span><BoldText text='105+' /> credit boost</span>;

const TextLowerInterest = () => <span><BoldText text='Lower interest' /> business loans</span>;

const CheckMarkTexts = ({
  className = '',
  textClassName = '',
}) => (
  <div className={className}>
    <CheckMarkText className={textClassName}>
      <TextCreditLine />
    </CheckMarkText>
    <CheckMarkText className={textClassName}>
      <TextCreditBoost />
    </CheckMarkText>
    <CheckMarkText className={textClassName}>
      <TextLowerInterest />
    </CheckMarkText>
  </div>
);

export default CheckMarkTexts;
